if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      let scrollTicking = false;
      const throttledScrollHandler = () => {
        if (!scrollTicking) {
          requestAnimationFrame(() => {
            this.setStickyClass();
            this.setHeaderOffset();
            this.setHeaderHeight();
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      };

      window.addEventListener('scroll', throttledScrollHandler, {
        passive: true
      });

      this.initialCalculations();
      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        if (!this._stickyOffset) {
          this._stickyOffset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        }
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      requestAnimationFrame(() => {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      });
    }
    setHeaderOffset() {
      requestAnimationFrame(() => {
        let h = this.header_section.getBoundingClientRect().top;
        document.documentElement.style.setProperty('--header-offset', h + 'px');
      });
    }
    setHeaderHeight() {
      requestAnimationFrame(() => {
        let h = this.clientHeight;
        document.documentElement.style.setProperty('--header-height', h + 'px');
      });
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    initialCalculations() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
      
      let offset = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', offset + 'px');
      const a_bar = document.querySelector('.announcement-bar-section');
      if (a_bar) {
        let ah = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', ah + 'px');
      }
      
      if (this.classList.contains('header-sticky--active')) {
        this._stickyOffset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      requestAnimationFrame(() => {
        const measurements = [];
        
        this.submenus.forEach((submenu) => {
          let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');
          
          sub_submenus.forEach((sub_submenu) => {
            let w = sub_submenu.offsetWidth,
              l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
              total = w + l;
              
            measurements.push({
              element: sub_submenu.parentElement,
              total: total,
              shouldAddClass: total > window.innerWidth
            });
          });
        });
        
        measurements.forEach(({ element, shouldAddClass }) => {
          if (shouldAddClass) {
            element.classList.add('left-submenu');
          } else if (element.classList.contains('left-submenu')) {
            element.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
}